<template>
  <v-container fluid class="width-100" v-if="getPermission('setting:view')"
    ><v-layout>
      <v-flex>
        <h3
          class="font-weight-700 mb-4 font-size-24 custom-headline color-custom-blue"
        >
          Project
        </h3>
      </v-flex>
      <v-flex class="text-right">
        <v-btn
          depressed
          class="custom-grey-border custom-bold-button"
          v-on:click="goBack"
        >
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </v-flex>
    </v-layout>
    <v-row>
      <v-col md="10">
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 85vh; position: relative"
        >
          <v-card flat class="custom-grey-border remove-border-radius mt-4">
            <v-card-title class="headline grey lighten-4">
              <v-row>
                <v-col md="4" class="py-0 my-auto">
                  <h3
                    class="font-weight-700 custom-headline color-custom-blue"
                    style="margin: 3.5px 0px"
                  >
                    Lift Renewal
                  </h3>
                </v-col>
                <template v-if="getPermission('setting:update')">
                  <v-col md="8" class="text-right py-0">
                    <div class="d-flex justify-content-end"></div>
                  </v-col>
                </template>
              </v-row>
            </v-card-title>
            <v-card-text
              class="p-6 font-size-16"
              :class="{
                'pointer-events-none': !getPermission('setting:update'),
              }"
            >
              <v-row>
                <v-col md="12" class="pb-4">
                  <v-simple-table
                    class="simple-table"
                    fixed-header
                    style="min-height: 200px"
                    :height="renewalTypeList?.length > 0 ? 'auto' : '100px'"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="simple-table-th px-1" width="50">#</th>
                          <th class="simple-table-th px-1" width="250">Name</th>
                          <th class="simple-table-th px-1">Period</th>
                          <th class="simple-table-th px-1">Description Text</th>
                          <th class="simple-table-th px-1" width="70">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="renewalTypeList?.length > 0">
                        <tr
                          v-for="(renewal, index) in renewalTypeList"
                          :key="index"
                          class="alternate-listing-row"
                        >
                          <td width="50" class="simple-table-td">
                            {{ index + 1 }}
                          </td>
                          <td
                            width="100"
                            class="simple-table-td text-capitalize"
                          >
                            <template v-if="renewal?.name">
                              {{ renewal?.name }}
                            </template>
                            <em v-else class="text-muted"> no name </em>
                          </td>
                          <td class="simple-table-td">
                            <template v-if="renewal?.period">
                              {{ renewal?.period }}
                            </template>
                            <em v-else class="text-muted"> no period </em>
                          </td>
                          <td class="simple-table-td">
                            <template v-if="renewal?.description">
                              <div v-html="renewal?.listing_desc"></div>
                            </template>
                            <em v-else class="text-muted"> no description </em>
                          </td>

                          <td class="simple-table-td">
                            <v-icon
                              color="cyan"
                              size="20"
                              v-on:click="updateRenewalType(renewal)"
                            >
                              mdi-pencil</v-icon
                            >
                          </td>
                        </tr>
                      </tbody>
                      <tr v-else>
                        <td colspan="5" class="py-4">
                          <p
                            class="m-0 row-not-found text-center font-weight-500 font-size-16"
                          >
                            <img
                              :src="$assetURL('media/error/empty.png')"
                              class="row-not-found-image"
                            />
                            Uhh... There are no lift renewal at the moment.
                          </p>
                        </td>
                      </tr>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <Dialog :common-dialog="confirm_dialog" :dialog-width="850">
            <template v-slot:title> Confirmation </template>
            <template v-slot:body>
              <v-form ref="statusForm" v-model.trim="formValid" lazy-validation>
                <v-container class="px-10" fluid>
                  <h3 class="font-weight-500 text-center">
                    Sub Location already exists in another transaction. Any
                    updates will be reflected in a new transaction.
                  </h3>
                </v-container>
              </v-form>
            </template>
            <template v-slot:action>
              <v-btn
                :disabled="confirm_loading"
                v-on:click="confirm_dialog = false"
                class="mx-2 custom-grey-border custom-bold-button"
              >
                No! Close
              </v-btn>
              <v-btn
                v-on:click="updateLocationSetting()"
                :disabled="!formValid || confirm_loading"
                :loading="confirm_loading"
                class="mx-2 custom-bold-button white--text"
                color="cyan"
              >
                Yes! Continue
              </v-btn>
            </template>
          </Dialog>
          <Dialog :commonDialog="liftRenewalDialog" :dialog-width="1200">
            <template v-slot:title>
              <template v-if="liftRenewalPayload?.id > 0">Edit</template
              ><template v-else>Add</template> Lift Renewal
            </template>
            <template v-slot:body>
              <v-container fluid>
                <v-form
                  ref="lifeRenewalReff"
                  v-model.trim="formValid"
                  lazy-validation
                  v-on:submit.stop.prevent="updateLocationSetting"
                >
                  <v-row>
                    <v-col md="6">
                      <label class="my-auto fw-500 required mb-1">Name </label>
                      <TextField
                        id="Name"
                        dense
                        filled
                        placeholder="Name"
                        readonly
                        solo
                        flat
                        counter="100"
                        v-model.trim="liftRenewalPayload.name"
                        color="cyan"
                        :maxlength="250"
                        :rules="[
                          validateRules.required(
                            liftRenewalPayload.name,
                            'Name'
                          ),
                        ]"
                      />
                    </v-col>
                    <v-col md="6">
                      <label class="my-auto fw-500 required mb-1"
                        >Period
                      </label>
                      <TextField
                        id="Period"
                        dense
                        filled
                        placeholder="Period"
                        solo
                        flat
                        counter="100"
                        v-model.trim="liftRenewalPayload.period"
                        color="cyan"
                        :maxlength="250"
                        :rules="[
                          validateRules.required(
                            liftRenewalPayload.period,
                            'Period'
                          ),
                        ]"
                      />
                    </v-col>
                    <v-col md="8">
                      <label class="my-auto fw-500 required mb-1"
                        >Description Text
                      </label>
                      <editor v-model="liftRenewalPayload.description" />
                    </v-col>
                    <v-col md="4">
                      <label class="my-auto fw-700 mb-1"
                        >Available Variables
                      </label>
                      <table width="100%" v-if="availableVariables?.length > 0">
                        <!-- <tr>
                          <td
                            class="color-custom-blue font-size-18 font-weight-600"
                          >
                            Variables
                          </td>
                        </tr> -->
                        <tr
                          v-for="(variable, index) in availableVariables"
                          :key="index"
                        >
                          <v-tooltip top content-class="custom-top-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                              <td
                                v-on:click="copyText(index, variable)"
                                ref="text"
                                v-bind="attrs"
                                v-on="on"
                                class="font-size-16 font-weight-600 cursor-pointer py-1"
                              >
                                {{ variable }}
                              </td>
                            </template>
                            <span>Click here to Copy</span>
                          </v-tooltip>
                        </tr>
                      </table>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </template>
            <template v-slot:action>
              <v-btn
                depressed
                :loading="pageLoading"
                :disabled="pageLoading || !formValid"
                class="mx-2 custom-grey-border custom-bold-button"
                color="cyan white--text"
                v-on:click="updateLocationSetting()"
              >
                Save
              </v-btn>
              <v-btn
                depressed
                :disabled="pageLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                v-on:click="liftRenewalDialog = false"
              >
                Close
              </v-btn>
            </template>
          </Dialog>

          <DeleteDialog :delete-dialog="deleteLocationDialog">
            <template v-slot:title>Delete Confirmation</template>
            <template v-slot:text>
              <h3 class="font-size-18 font-weight-600 delete-text">
                Are you sure you want to delete this sub location ?
              </h3>
            </template>
            <template v-slot:action>
              <v-btn
                depressed
                :disabled="deleteLocationLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                v-on:click="deleteLocationDialog = false"
                >No! Cancel</v-btn
              >
              <v-btn
                depressed
                :disabled="deleteLocationLoading"
                :loading="deleteLocationLoading"
                color="red lighten-1 white--text"
                v-on:click="deleteLocationConfirm()"
                class="mx-2 custom-grey-border custom-bold-button"
                >Yes! Delete</v-btn
              >
            </template>
          </DeleteDialog>
        </perfect-scrollbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { GET, PATCH } from "@/core/services/store/request.module";
import Dialog from "@/view/pages/partials/Dialog.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";
import DeleteDialog from "@/view/pages/partials/Delete";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import TinyMCE from "@/view/pages/partials/TinyMCE.vue";
import { SuccessEventBus, ClearEventBus } from "@/core/lib/message.lib";
export default {
  name: "profile-property-setting",
  mixins: [ValidationMixin],
  data() {
    return {
      deleteLocationLoading: false,
      pageLoading: true,
      liftRenewalPayload: {
        name: null,
        period: null,
        description: null,
      },
      availableVariables: new Array(),
      propertPageLoading: false, // or your actual loading state variable
      itemsPerPage: 10,
      location_id: 0,
      currentPage: 1,
      is_exist: 0,
      confirm_dialog: false,
      confirm_loading: false,
      deleteLocationDialog: false,
      liftRenewalDialog: false,
      renewalTypeList: [],
      dataLoading: false,
      setting: {
        prefix: null,
        next_number: null,
        number_length: null,
        remarks: null,
      },
    };
  },
  components: {
    Dialog,
    DeleteDialog,
    editor: TinyMCE,
  },
  methods: {
    selectText(element) {
      let range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    copyText(index, variable) {
      try {
        console.log({ index });
        navigator.clipboard.writeText(variable);
        ClearEventBus.$emit("clear:success");
        SuccessEventBus.$emit(
          "update:success",
          variable + " copied successfully."
        );

        /*        
        this.selectText(this.$refs.text[index]);
        document.execCommand("copy");
        console.log({ variable });
        ClearEventBus.$emit("clear:success");
        SuccessEventBus.$emit(
          "update:success",
          variable + " copied successfully."
        );
        window.getSelection().removeAllRanges(); */
      } catch (error) {
        this.logError(error);
      }
    },

    updateRenewalType(param) {
      const _this = this;

      _this.liftRenewalPayload = {
        id: null,
        name: null,
        period: null,
        description: null,
      };
      _this.$store
        .dispatch(GET, { url: `left-renewal/${param.id}` })
        .then(({ data }) => {
          _this.liftRenewalPayload = {
            id: _this.lodash.toSafeInteger(data.id),
            name: data?.name ? data.name : null,
            period: data?.period ? data.period : null,
            description: data?.description ? data.description : null,
          };
          this.availableVariables = data.variables;
          this.liftRenewalDialog = true;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    updateLocationSetting() {
      const _this = this;
      const formErrors = _this.validateForm(_this.$refs.lifeRenewalReff);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
          _this.pageLoading = false;
        }
        return false;
      }

      _this.pageLoading = true;
      _this.dataLoading = true;

      _this.$store
        .dispatch(PATCH, {
          url: "setting/lift-renewal",
          data: _this.liftRenewalPayload,
        })
        .then(() => {
          _this.getRenewalSetting();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
          _this.pageLoading = false;
          _this.liftRenewalDialog = false;
        });
    },

    getRenewalSetting() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "setting/left-renewal" })
        .then(({ data }) => {
          _this.renewalTypeList = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    handlePageChange(page) {
      this.propertPageLoading = true;
      this.currentPage = page;
      setTimeout(() => {
        this.propertPageLoading = false;
      }, 1000);
    },
  },
  mounted() {
    this.getRenewalSetting();
  },
  computed: {},
};
</script>
